module.exports = __webpack_public_path__ + "static/media/navbar-logo.48bb88c8.png";